import { CartPlugin } from '@api/local/CartPlugin'
import { ModalsPlugin } from '@api/local/ModalsPlugin'
import { NavigationPlugin } from '@api/local/NavigationPlugin'
import { OrderPlugin } from '@api/local/OrderPlugin'
import { ProductPlugin } from '@api/local/ProductPlugin'
import { UserPlugin } from '@api/local/UserPlugin'
import { Config } from '@lib/Config'
import { GTM } from '@lib/GTM'
import { UserEvents } from '@lib/UserEvents'

import { AppPlugin, UserMenuPlugin } from './api/local/index'

export async function configure(config: Config, events?: UserEvents): Promise<void> {

  const appPlugin = AppPlugin.shared()
  config.registerPlugin(appPlugin)

  const cartPlugin = CartPlugin.shared()
  config.registerPlugin(cartPlugin)

  const modalsPlugin = ModalsPlugin.shared()
  config.registerPlugin(modalsPlugin)

  const navigationPlugin = NavigationPlugin.shared()
  config.registerPlugin(navigationPlugin)

  const userPlugin = UserPlugin.shared()
  config.registerPlugin(userPlugin)

  const productPlugin = new ProductPlugin()
  config.registerPlugin(productPlugin)

  const orderPlugin = new OrderPlugin()
  config.registerPlugin(orderPlugin)

  const userMenuPlugin = new UserMenuPlugin()
  config.registerPlugin(userMenuPlugin)

  await config.configureApp()

  // WARNING: The following code can cause ReferenceError: module is not defined from react-onesignal/index.ts
  // if any imported dependency (such as GTM or its plugins) statically imports browser-only modules.
  // This happens during server-side or Node.js execution (e.g., npm run schema:fetch), even if guarded by isBrowser().
  // To avoid this, ensure all browser-only imports are inside the isBrowser() block or use dynamic imports.
  if (config.isBrowser()) {
    const gtm = new GTM('GTM-KQBXJTG', 'ga4_')
    events.registerPlugin(gtm)
  }

}
